module.exports = __webpack_public_path__ + "img/bj_2.50e25eee.png";